import { CountryAlpha2, CountryAlpha3 } from '@nemuru-eng/js-api-client';
import { z } from 'zod';

import { GetTextIdTranslationType } from '@/components/shared/hooks/useTranslation';
import { maxStringMessage, postalCodeValidation, requiredString } from '@/utils/zodUtils';

export const AddressObjectSchema = (t: GetTextIdTranslationType) =>
  z.object({
    address: z.string(),
    streetName: requiredString(t).max(50, maxStringMessage(t)),
    streetNumber: requiredString(t),
    postalCode: requiredString(t),
    city: requiredString(t).max(30, maxStringMessage(t)),
    province: requiredString(t),
    country: requiredString(t),
    countryLongName: z.string(),
    region: z.string().optional(),
    regionShortName: z.string().optional(),
    provinceShortName: z.string().optional(),
    latitude: z.number().optional(),
    longitude: z.number().optional(),
    floorNumber: z.string().max(2, maxStringMessage(t)).optional(),
    doorNumber: z.string().max(1, maxStringMessage(t)).optional(),
    building: z.string().max(5, maxStringMessage(t)).optional(),
  });

export const AddressSchema = (t: GetTextIdTranslationType) =>
  AddressObjectSchema(t).refine(
    (data) =>
      !data.country || postalCodeValidation(data.country as CountryAlpha2 | CountryAlpha3, data.postalCode as string),
    { message: t('INVALID_POSTAL_CODE'), path: ['postalCode'] },
  );

export type AddressSchemaType = z.infer<ReturnType<typeof AddressObjectSchema>>;
